/**
 * Copyright (c) 2018-present clchart Contributors.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

//   时间处理函数

/** @module ClTool */

////////////////////////////////
// 标准 HASH 数学相关函数
////////////////////////////////
// const CryptoJS = require('crypto-js');

// function getHashFromString(str) {
//     // 使用 SHA-256 算法计算哈希值
//     return CryptoJS.SHA1(str).toString();
// }

// const longString1 = '这是一个很长的字符串，用于测试哈希值生成。';
// const longString2 = '这是一个很长的字符串，用于测试哈希值生成。';
// const longString3 = '这是一个不同的很长的字符串，用于测试哈希值生成。';

// const hash1 = getHashFromString(longString1);
// const hash2 = getHashFromString(longString2);
// const hash3 = getHashFromString(longString3);

// console.log('字符串1的哈希值:', hash1);
// console.log('字符串2的哈希值:', hash2);
// console.log('字符串3的哈希值:', hash3);

// // 判断字符串是否相同
// console.log('字符串1和字符串2是否相同:', hash1 === hash2); 
// console.log('字符串1和字符串3是否相同:', hash1 === hash3);     

export function getHashStr(str, mod = 1000000) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = (hash * 31 + str.charCodeAt(i)) % mod;
    }
    return hash.toString(16);
}

/**
 * add prefix with 0
 * @export
 * @param {Number} v
 * @param {Number} n
 * @return {String}
 */
export function addPreZero(v, n) { // n表示总共几位  (9,2) ---09
    n = n > 9 ? 9 : n
    const s = '000000000' + v
    return s.slice(-1 * n)
}
/**
 * get random text
 * @export
 * @param {Number} size
 * @return {String}
 */
function makeId(size) {
    let text = ''
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    if (size > 20) size = 20;
    for (let i = 0; i < size; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
    }

    return text
}

////////////////////////////////////////////////
// 时间 操作相关
////////////////////////////////////////////////

export function getNowMsec() {
    let mtime = new Date()
    return mtime.getTime()
}
/**
 * get time's millseconds
 * @export
 * @param {any} ttime
 * @return {Number}
 */
export function getMTime(ttime) { // 得到1970-1-1开始的毫秒数
    let mtime, seconds
    if (ttime === undefined) {
        mtime = new Date()
    } else {
        if (typeof ttime === 'string') {
            seconds = parseInt(ttime)
        } else {
            seconds = ttime
        }
        if (!isNaN(seconds)) {
            mtime = new Date(seconds * 1000)
        } else {
            mtime = new Date()
        }
    }
    return mtime
}

export function getMsecDate(msec) {
    let mtime = new Date(msec);
    return mtime.getFullYear() * 10000 + (mtime.getMonth() + 1) * 100 + mtime.getDate()
}
export function getNowDate() {
    let mtime = new Date();
    return mtime.getFullYear() * 10000 + (mtime.getMonth() + 1) * 100 + mtime.getDate()
}
export function getMsecMinu(msec) {
    const mtime = new Date(msec);
    return mtime.getHours() * 100 + mtime.getMinutes()
}

export function getDate(ttime) {
    const mtime = getMTime(ttime)
    return mtime.getFullYear() * 10000 + (mtime.getMonth() + 1) * 100 + mtime.getDate()
}
// time_t提取其中的分钟 1030
export function getMinute(ttime) {
    const mtime = getMTime(ttime)
    return mtime.getHours() * 100 + mtime.getMinutes()
}
// 求星期几 0-周日 6-周六
export function getDayWeek(day) {
    const mtime = new Date(Math.floor(day / 10000), Math.floor((day % 10000) / 100) - 1, day % 100)
    return mtime.getDay()
}
// 求星期几 0-周日 6-周六
export function getDayMon(day) {
    const mtime = new Date(Math.floor(day / 10000), Math.floor((day % 10000) / 100) - 1, day % 100)
    return mtime.getMonth() + 1
}
// 日期转换成time_t
function _dayToTTime(day) {
    const mtime = new Date(Math.floor(day / 10000), Math.floor((day % 10000) / 100) - 1, day % 100)
    return mtime / 1000
}
// 得到两个日期间隔的天数
export function getDayGap(beginDay, endDay) {
    return Math.floor((_dayToTTime(endDay) - _dayToTTime(beginDay)) / (24 * 3600))
}

// 格式化time_t为指定字符串
export function fromTTimeToStr(ttime, format, ttimePre) {
    const mtime = getMTime(ttime)
    switch (format) {
        case 'minute':
            if (ttimePre === undefined) {
                return mtime.getHours() + ':' + addPreZero(mtime.getMinutes(), 2)
            } else {
                if (getMinute(ttime) === getMinute(ttimePre)) {
                    return ':' + addPreZero(mtime.getSeconds(), 2)
                } else {
                    return mtime.getHours() + ':' + addPreZero(mtime.getMinutes(), 2)
                }
            }
            case 'datetime':
                return mtime.getFullYear() * 10000 + (mtime.getMonth() + 1) * 100 + mtime.getDate() +
                    '-' + mtime.getHours() + ':' + addPreZero(mtime.getMinutes(), 2)
            default:
                return ''
    }
}

// 分钟转字符串 1500 -- 15:00
export function fromMinuteToStr(minute) {
    return addPreZero(Math.floor(minute / 100), 2).toString() + ':' + addPreZero(minute % 100, 2).toString()
}
// 得到间隔分钟数
export function getMinuteGap(beginMin, endMin) {
    return (Math.floor(endMin / 100) - Math.floor(beginMin / 100)) * 60 + endMin % 100 - beginMin % 100
}

// 偏移分钟数，offset 为分钟数
export function getMinuteOffset(minute, offset) {
    const mincount = Math.floor(minute / 100) * 60 + minute % 100 + offset
    return Math.floor(mincount / 60) * 100 + mincount % 60
}

// '2025-03-21 10:10:10.000' --> 1742523010000
// '2025-03-21 10:10:10' --> 1742523010000
export function strMsecToMTime(instr) {
    // 把字符串中的空格替换为 'T'，以符合 ISO 8601 格式
    const isostr = instr.replace(' ', 'T');
    const dmsec = new Date(isostr);
    return dmsec.getTime();
}

export function strMsecTostrTime(instr) {
    // 把字符串中的空格替换为 'T'，以符合 ISO 8601 格式
    const isostr = instr.replace(' ', 'T');
    const dmsec = new Date(isostr);
    return addPreZero(dmsec.getHours(), 2) + ':' + addPreZero(dmsec.getMinutes(), 2)
}

export function strMsecTostrDate(instr) {
    // 把字符串中的空格替换为 'T'，以符合 ISO 8601 格式
    const isostr = instr.replace(' ', 'T');
    const dmsec = new Date(isostr);
    return dmsec.getFullYear() * 10000 + (dmsec.getMonth() + 1) * 100 + dmsec.getDate()
}

// 根据交易时间把time_t返回一个顺序值 time_t --> 0..239 -1表示没有非交易时间
/**
 * convert time t to trade time
 * @export
 * @param {Number} ttime
 * @param {Number} tradetime
 * @return {Number}
 */
// 需要增加 9 : 30 的信息 - 一共 241 条记录 
export function fromTradeTimeToIndex (ttime, tradetime) { // time_t 返回 0 － 240
  const minute = getMinute(ttime)

  let nowmin = 0
  let index = -1
  for (let i = 0; i < tradetime.length; i++) {
    // 9:31:00--11:29:59  13:01:00--14:59:59
    if (minute > tradetime[i][0] && minute <= tradetime[i][1]) {
        index = nowmin + getMinuteGap(tradetime[i][0], minute)
        break
    }
    if (minute <= tradetime[i][0] && i === 0) { // 8:00:00---9:30:59秒前都=0
        return 0
    }
    if (minute <= tradetime[i][0] && (minute > getMinuteOffset(tradetime[i][0], -5))) { // 12:55:59--13:00:59秒
        return nowmin
    }

    nowmin += getMinuteGap(tradetime[i][0], tradetime[i][1])
    if (minute > tradetime[i][1] && i === tradetime.length - 1) { // 15:00:00秒后
        return nowmin
    }
    if (minute > tradetime[i][1] && (minute < getMinuteOffset(tradetime[i][1], 5))) { // 11:30:00--11:34:59秒
        return nowmin
    }
  }
  return index
}
export function getTradeMsecToIndex (msec, tradetime) { // msec 返回 ０－２３９
    return fromTradeTimeToIndex(msec/1000, tradetime)
}
////////////////////////////////////////////////
// 数组和对象操作相关
////////////////////////////////////////////////

// 检索数据函数集
export function getSize (source) {
  if (source === undefined || isEmptyArray(source.value)) {
    return 0
  }
  return source.value.length
}
// 判断 v 是否在数组arr中, 比in准确
export function inArray(v, arr) {
    if (arr.indexOf(v) < 0) return false
    return true
}
// 求数组a和b的交集
export function intersectArray(a, b) {
    const result = []
    for (let ai = 0; ai < a.length; ai++) {
        for (let bi = 0; bi < b.length; bi++) {
            if (a[ai] === b[bi]) {
                result.push(a[ai])
                break
            }
        }
    }
    return result
}
// 求数组a和b的并集,去掉重复的元素
export function mergeArray(a, b) {
    const result = []
    for (let ai = 0; ai < a.length; ai++) {
        result.push(a[ai])
    }
    for (let bi = 0; bi < b.length; bi++) {
        if (!inArray(b[bi], result)) {
            result.push(b[bi])
        }
    }
    return result
}
// 不生成新的数组 把incrs添加到 source 中 imode 'after' 从后面增加 'before' 从前面增加
export function incrArray(source, incrs, imode) {
    if (imode === undefined) imode = 'after'
    if (imode === 'before') {
        for (let bi = incrs.length - 1; bi >= 0; bi--) {
            source.unshift(incrs[bi])
        }
    } else {
        for (let bi = 0; bi < incrs.length; bi++) {
            source.push(incrs[bi])
        }
    }
}

export function copyArrayOfDeep(obj) {
    let out
    if (Array.isArray(obj)) {
        out = []
        const len = obj.length
        for (let i = 0; i < len; i++) {
            out[i] = copyArrayOfDeep(obj[i])
        }
    } else {
        out = obj
    }
    return out
}
export function copyJsonOfDeep(obj) {
    let out
    if (obj instanceof Object) { // 数组和文档都为真
        if (Array.isArray(obj)) { // 只有数组为真
            out = copyArrayOfDeep(obj)
        } else {
            out = {}
            for (const key in obj) {
                out[key] = copyJsonOfDeep(obj[key])
            }
        }
    } else {
        out = obj
    }
    return out
}

// 替换source中存在的对应元素 增加source中不存在的数据
// 例如 source = {a:1,b:2} newobj = {a:5, c:10}
// source = {a:5, b:2, c:10}
export function setJsonOfDeep(source, newobj) {
    // console.log(source, newobj);
    if (newobj instanceof Object) { // 数组和文档都为真
        if (!Array.isArray(newobj)) { // 只有数组为真
            for (const key in newobj) {
                if (newobj[key] instanceof Object && !Array.isArray(newobj[key])) {
                    setJsonOfDeep(source[key], newobj[key])
                } else {
                    source[key] = newobj[key]
                    // console.log('--', key, source[key], newobj[key]);
                }
            }
        }
    }
}

function isValue(obj) {
    if (obj === undefined) return false
    // if (isNaN(obj)) return false
    return true
}
// obj为子集，生成新的对象，仅仅替换source中存在的对应元素
// 例如 obj = {a:[111],b:2} source = {a:[1,2,3]}
// out = {a:[111,2,3]}
export function updateJsonOfDeep(obj, source) {
    let out
    if (source instanceof Object) {
        if (Array.isArray(source)) {
            out = []
            for (const key in source) {
                out[key] = isValue(obj) && isValue(obj[key]) ?
                    updateJsonOfDeep(obj[key], source[key]) :
                    copyArrayOfDeep(source[key])
            }
        } else {
            out = {}
            for (const key in source) {
                out[key] = isValue(obj) && isValue(obj[key]) ?
                    updateJsonOfDeep(obj[key], source[key]) :
                    copyJsonOfDeep(source[key])
            }
        }
    } else {
        out = isValue(obj) ? obj : source
    }
    return out
}
// obj为原始集，不生成新的对象，用source中存在的对应元素替换obj的数据
// 如果原始集没有 就增加key
// 例如 obj = {a:[111],b:2} source = {a:[1,2,3],c:1}
// out = {a:[111,2,3],b:2,c:1}
export function mergeJsonOfDeep(obj, newobj) {
    Object.keys(newobj).forEach(key => {
        if (newobj[key] instanceof Object) {
            if (Array.isArray(newobj[key])) {
                obj[key] = copyArrayOfDeep(newobj[key])
            } else {
                obj[key] = copyJsonOfDeep(newobj[key])
            }
        }
        else {
            obj[key] = newobj[key]
        }
    });
}

// target 为用户集合 source为预定义集合 生成新的对象
// source 中不存在的对象 新集合也不存在
// source 中存在的对象 target 不存在直接赋值
// source 中存在的对象 target 存在的情况
//     为值直接替换
//     为数组 target 增加到 source 后
//     为对象 递归处理
// 例如 obj = {a:[111], b:2} source = {a:[1,2,3], c:1}
// out = {a:[1,2,3,111], c:1}
export function copyObjectOfDeep(source) {
    let result
    if (typeof source === 'object') {
        if (Array.isArray(source)) {
            result = []
            for (let i = 0; i < source.length; i++) {
                result[i] = copyObjectOfDeep(source[i])
            }
        }
        else {
            result = {}
            for (const skey in source) {
                result[skey] = copyObjectOfDeep(source[skey])
            }
        }
    } else {
        result = source
    }
    return result
}

export function mergeObjectOfDeep(target, source) {
    let result
    if (typeof source === 'object' && typeof target === 'object') {
        if (Array.isArray(source)) {
            result = []
            for (let index = 0; index < source.length; index++) {
                result[index] = copyObjectOfDeep(source[index])
            }
        } else {
            result = {}
            for (const skey in source) {
                // console.log(source[skey], target, skey);
                if (target[skey] === undefined) {
                    result[skey] = copyObjectOfDeep(source[skey])
                }
                else {
                    result[skey] = mergeObjectOfDeep(target[skey], source[skey])
                }
            }
        }
        if (Array.isArray(target)) {
            result = []
            for (let index = 0; index < target.length; index++) {
                result[index] = copyObjectOfDeep(target[index])
            }
        }
    } else {
        if (target === undefined) {
            result = source
        } else {
            result = target
        }
    }
    return result

}

// 把回车分割的对象转换为数组对象
function convertToObjectArray(str) {
  // 按换行符分割字符串
  const parts = str.split('\n');
  
  // 过滤空字符串并解析每个对象
  return parts
    .filter(item => item.trim() !== '') // 移除空行
    .map(item => {
      try {
        // 将字符串解析为对象
        return JSON.parse(item);
      } catch (error) {
        console.error('解析对象失败:', error, '有问题的字符串:', item);
        return null; // 解析失败时返回null，可根据需求处理
      }
    })
    .filter(item => item !== null); // 过滤解析失败的项
}

// 数组是否为空
export function isEmptyArray(obj) {
    if (obj !== undefined && Array.isArray(obj)) {
        if (obj.length > 0) return false
    }
    return true
}

////////////////////////////////////////////////
// 画图相关
////////////////////////////////////////////////

// 根据offset返回一个新的矩形
// rect:{left,top,width,height}
// offset:{left,top,right,bottom}
export function offsetRect(rect, offset) {
    if (rect === undefined) return {
        left: 0,
        top: 0,
        width: 0,
        height: 0
    }
    if (offset === undefined) return rect
    return {
        left: rect.left + offset.left,
        top: rect.top + offset.top,
        width: rect.width - (offset.left + offset.right),
        height: rect.height - (offset.top + offset.bottom)
    }
}
export function resumeRect(rect, offset) {
    return {
        left: rect.left - offset.left,
        top: rect.top - offset.top,
        width: rect.width + (offset.left + offset.right),
        height: rect.height + (offset.top + offset.bottom)
    } 
}

export function getRectY(rect, yy) {
    if (rect === undefined || yy === undefined) return yy
    if (yy < rect.top) {
        return rect.top + 1
    }
    else if (yy > (rect.top + rect.height)) {
        return rect.top + + rect.height - 1
    }
    return yy
}
// 判断点是否在矩形内
export function inRect(rect, point) {
    if (rect === undefined || point === undefined) return false
    if (point.x >= rect.left && point.y >= rect.top &&
        point.x <= (rect.left + rect.width) &&
        point.y <= (rect.top + rect.height)) {
        return true
    }
    return false
}
// 判断X是否在矩形宽度范围内
export function inRangeX(rect, xx) {
    if (rect === undefined || xx === undefined) return false
    if (xx >= rect.left &&
        xx <= (rect.left + rect.width)) {
        return true
    }
    return false
}
// 判断Y是否在矩形高度范围内
export function inRangeY(rect, yy) {
    if (rect === undefined || yy === undefined) return false
    if (yy >= rect.top &&
        yy < (rect.top + rect.height)) {
        return true
    }
    return false
}

// 格式化百分比
export function formatRate(value, zero) {
    if (value === undefined || isNaN(value) || zero === undefined) return '--'
    if (typeof value === 'string') value = parseFloat(value)

    let result = Math.abs((value - zero) / zero * 100)
    result = result.toFixed(2) + '%'
    return result // 10.20%
}
export function formatInteger(value) {
    if (value === undefined || isNaN(value)) return '0'
    let result = value.toFixed(0)
    return String(result)
}
export function formatFloat(value, coindot, maxchs) {
    if (value === undefined || isNaN(value)) return '0'
    let result = value
    if (coindot === undefined || coindot < 0 || coindot > 10) coindot = 0

    if (value > -0.000000001 && value < 0.000000001) {
        return '0.0'
    }
    if (value > 100000000.0 || value < -100000000.0) {
        result = value / 100000000.0
        result = result.toFixed(0) + '亿'
    }
    else if (value > 10000.0 || value < -10000.0) {
        result = value / 10000.0
        result = result.toFixed(0) + '万'
    }
    else if (value < -999.99 ) {
        result = result.toFixed(coindot - 1)
    }
    else {
        result = result.toFixed(coindot)
    }
    return result;
}

// 格式化成交量
export function formatVolume(value, volunit) {
    if (value === undefined || isNaN(value)) return '0'
    if (typeof value === 'string') value = parseFloat(value)

    if (volunit === undefined) volunit = 1
    let result = value * volunit

    if (result >= 100000000000) result = (result / 100000000).toFixed(0) + '亿'
    else if (result >= 10000000000) result = (result / 100000000).toFixed(1) + '亿'
    else if (result >= 1000000000) result = (result / 100000000).toFixed(2) + '亿'
    else if (result >= 100000000) result = (result / 100000000).toFixed(3) + '亿'
    else if (result >= 10000000) result = (result / 10000).toFixed(0) + '万'
    else if (result >= 1000000) result = (result / 10000).toFixed(1) + '万'
    else if (result > -0.000000001 && result < 0.000000001) result = '0'
    else result = result.toFixed(0)
    return String(result)
}

// 格式化资金 有负数
export function formatMoney(value, mnyunit) {
    if (value === undefined || isNaN(value)) return '0'
    if (typeof value === 'string') value = parseFloat(value)

    if (mnyunit === undefined) mnyunit = 1
    let result = value * mnyunit

    // if (result > 100000000000) result = (result / 100000000).toFixed(0) + '亿'
    if (Math.abs(result) > 10000000000) result = (result / 100000000).toFixed(0) + '亿'
    else if (Math.abs(result) > 1000000000) result = (result / 100000000).toFixed(1) + '亿'
    else if (Math.abs(result) > 100000000) result = (result / 100000000).toFixed(2) + '亿'
    else if (Math.abs(result) > 10000000) result = (result / 10000).toFixed(0) + '万'
    else if (Math.abs(result) > 1000000) result = (result / 10000).toFixed(0) + '万'
    else if (Math.abs(result) > 100000) result = (result / 10000).toFixed(0) + '万'
    else if (Math.abs(result) < 0.000000001) result = '0'
    else result = result.toFixed(0)

    return String(result)
}
// 格式化价格 decimal为小数点，limit为最大长度[4,10]，
export function formatPrice(value, coindot, limit, isopen) {
    if (value === undefined || isNaN(value)) return '--'
    // if (typeof value === 'string') value = parseFloat(value);
    if (coindot === undefined) coindot = 2

    let result = value
    if (coindot === undefined || coindot < 0 || coindot > 10) coindot = 0

    if (value > -0.000000001 && value < 0.000000001 && !isopen) {
        return '--'
    }
    result = result.toFixed(coindot)
    // console.log(limit, coindot);
    return result
    
    // if (limit === undefined || limit < 4) return result.toFixed(coindot)
    // return result.substr(0, limit)
}

// 格式化时间
export function formatMsecMinute(value, format) {
    let out = '--'
    switch (format) {
        case 'M5':
        case 'M15':
        case 'M30':
        case 'M60':
            out = fromTTimeToStr(value / 1000, 'datetime')
            break
        case 'minute':
        default :
            out = fromTTimeToStr(value / 1000, 'minute')
            break
    }
    return out
}

export function formatInfo(value, format, stkinfo) {
    let out
    if (format === 'rate') {
        // out = value; // 
        out = formatRate(value, stkinfo.agoprc)
    } else {
        if (format === 'price') {
            out = formatPrice(value, stkinfo.coindot, 7)
        } else if (format === 'float') {
            out = formatFloat(value, stkinfo.coindot, 7)
        } else if (format === 'double') {
            out = formatFloat(value, 3, 7)
        } else if (format === 'integer') {
            out = formatInteger(value)
        } else if (format === 'money') {
            out = formatMoney(value, 1)
        } else if (format === 'hand') {
            out = formatVolume(value / 100, 1)
        }
        else {
            out = formatVolume(value, 1)
        }
    }
    return out
}

// 得到渐变颜色数组
export function getGradientColors(startColor, endColor, steps) {
    // 将十六进制颜色转换为 RGB 数组
    function hexToRgb(hex) {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return [r, g, b];
    }

    // 将 RGB 数组转换为十六进制颜色
    function rgbToHex(r, g, b) {
        return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }

    const startRgb = hexToRgb(startColor);
    const endRgb = hexToRgb(endColor);
    const colors = [];

    for (let i = 0; i < steps; i++) {
        const ratio = i / (steps - 1);
        const r = Math.round(startRgb[0] + ratio * (endRgb[0] - startRgb[0]));
        const g = Math.round(startRgb[1] + ratio * (endRgb[1] - startRgb[1]));
        const b = Math.round(startRgb[2] + ratio * (endRgb[2] - startRgb[2]));
        colors.push(rgbToHex(r, g, b));
    }

    return colors;
}

////////////////////////////////////////////////
// 字符串操作 相关
////////////////////////////////////////////////

export function strIncludes(str, arr) {
    return arr.some(i => str.includes(i))
}
    
export function changeSortMode(sortmode) {
    if (sortmode === undefined || sortmode === 'preface') {
        sortmode = 'descending'
    } else if (sortmode === 'descending') {
        sortmode = 'ascending'
    } else {
        sortmode = 'preface'
    }
    return sortmode
}
// 对二维数组中整数列进行升序排序 style = 1 降序 style = 0 升序
export function sortNumberArray(arr, columnIndex, sortmode) {
    if (sortmode === undefined || sortmode === 'ascending') {
        return arr.sort((a, b) => parseFloat(a[columnIndex]) - parseFloat(b[columnIndex]));
    } else {
        return arr.sort((a, b) => parseFloat(b[columnIndex]) - parseFloat(a[columnIndex]));
    }
}
// 对二维数组中字符串列进行升序排序
export function sortStringArray(arr, columnIndex, sortmode) {
    return arr.sort((a, b) => {
        const valueA = a[columnIndex].toLowerCase();
        const valueB = b[columnIndex].toLowerCase();
        if (valueA < valueB) {
            return (sortmode === undefined || sortmode === 'ascending') ? -1 : 1;
        }
        if (valueA > valueB) {
            return (sortmode === undefined || sortmode === 'ascending') ? 1 : -1;
        }
        return 0;
    });
}

